const map = {
	"./board/corner-bottom-left.png": 4694,
	"./board/corner-bottom-right.png": 6385,
	"./board/corner-top-left.png": 8894,
	"./board/corner-top-right.png": 4601,
	"./board/hole.png": 5455,
	"./board/plank-bottom.png": 4590,
	"./board/plank-left.png": 7771,
	"./board/plank-right.png": 9050,
	"./board/plank-top.png": 1979,
	"./buttons/button-large-border.png": 8999,
	"./buttons/button-medium-border.png": 3395,
	"./buttons/button-nav-border.png": 5061,
	"./flag/flag-normal.png": 7251,
	"./flag/flag-ripped.png": 4076,
	"./gems/border-default.png": 4977,
	"./gems/broken-shadow.png": 9431,
	"./gems/gem-apple.png": 3205,
	"./gems/gem-blue.png": 3825,
	"./gems/gem-bone.png": 6367,
	"./gems/gem-brick.png": 4708,
	"./gems/gem-bronze.png": 141,
	"./gems/gem-caviar.png": 7599,
	"./gems/gem-cheese.png": 6924,
	"./gems/gem-coral.png": 7492,
	"./gems/gem-foam.png": 1524,
	"./gems/gem-football.png": 1232,
	"./gems/gem-geode.png": 843,
	"./gems/gem-gold-stone.png": 1471,
	"./gems/gem-gold.png": 4199,
	"./gems/gem-golf.png": 6021,
	"./gems/gem-grass.png": 5083,
	"./gems/gem-green.png": 1446,
	"./gems/gem-honey.png": 6626,
	"./gems/gem-ice.png": 858,
	"./gems/gem-lava.png": 1007,
	"./gems/gem-marble.png": 1512,
	"./gems/gem-neutral.png": 9650,
	"./gems/gem-onion.png": 6224,
	"./gems/gem-orange.png": 7499,
	"./gems/gem-paua.png": 9456,
	"./gems/gem-pearl.png": 1169,
	"./gems/gem-pinecone.png": 8444,
	"./gems/gem-pumpkin.png": 5181,
	"./gems/gem-purple.png": 1643,
	"./gems/gem-red.png": 650,
	"./gems/gem-scarab.png": 4499,
	"./gems/gem-silver-stone.png": 4584,
	"./gems/gem-silver.png": 6664,
	"./gems/gem-slime.png": 2301,
	"./gems/gem-star.png": 3157,
	"./gems/gem-sushi.png": 4299,
	"./gems/gem-tennis.png": 4154,
	"./gems/gem-void.png": 7211,
	"./gems/gem-vortex.png": 9425,
	"./gems/gem-wood.png": 8236,
	"./gems/gem-yarn.png": 3647,
	"./gems/gem-yellow.png": 7709,
	"./logo.png": 5835,
	"./logo/logo-full.png": 5635,
	"./panel/panel-border-bottom.png": 5246,
	"./panel/panel-border-left.png": 1008,
	"./panel/panel-border-right.png": 5963,
	"./panel/panel-border-top.png": 3910,
	"./panel/store-tablet-landscape.png": 1779,
	"./round-button/round-button-bg-pressed.png": 7142,
	"./round-button/round-button-bg.png": 5673
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2561;